import { Component } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Translation } from '../../providers/translation';
import { Topbar } from '../../providers/topbar';
import { PaymentService } from '../payment/payment.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators/filter';
import { tap } from 'rxjs/operators/tap';
import { ISession } from '../../models/session';
import { eva_constants } from '../../eva_constants';

@Component({
  selector: 'app-topnavbar',
  templateUrl: './topnavbar.component.html',
  styleUrls: ['./topnavbar.component.scss']
})
export class TopnavbarComponent {
  private theme: string;
  public session: ISession = null;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    public translation: Translation,
    public topbar: Topbar,
    public paymentService: PaymentService
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          if (!this.route.snapshot.firstChild) return;
          this.session = null;
          const { data } = this.route.snapshot.firstChild;
          this.theme = data['theme'];
          if (data && data['data'] && this.isSession(data['data'])) {
            this.session = data['data'];
          }
        })
      )
      .subscribe(null);
  }

  logout() {
    this.authService.logout();
  }

  isSession(data) {
    return 'id' in data && 'name' in data && 'types' in data;
  }

  isLivee() {
    return this.theme === eva_constants.LIVEE_THEME;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/topnavbar/topnavbar.component.ts